import { useEffect } from 'react';
import { APIError, RtnResponse } from './api-response.type';

interface RtnResponseOptions<T = unknown> {
  payload: RtnResponse<T> | null | undefined;
  onSuccess?: (data: T, payload: RtnResponse<T>) => void;
  onError?: (error: Error) => void;
}

export function useRtnResponse<T>({
  payload,
  onSuccess,
  onError,
}: RtnResponseOptions<T>) {
  useEffect(() => {
    if (!payload) return;

    if (payload.rtnCode === -1) {
      const apiError = new APIError({ message: payload.rtnMsg });
      onError?.(apiError);
    }

    onSuccess?.(payload.data, payload);
  }, [payload, onSuccess, onError]);
}
